exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".C6tBDBxLorhG5d1q1VRri {\n  width: 100%;\n  margin-bottom: 15px; }\n  .C6tBDBxLorhG5d1q1VRri > span {\n    display: flex;\n    color: black;\n    justify-content: space-between;\n    align-content: center;\n    align-items: center;\n    height: 30px; }\n    .C6tBDBxLorhG5d1q1VRri > span > button {\n      color: #484848;\n      background: transparent;\n      border: 1px solid #e4e7e7;\n      border-radius: 5px;\n      width: 30px;\n      height: 30px; }\n", ""]);

// Exports
exports.locals = {
	"container": "C6tBDBxLorhG5d1q1VRri"
};